import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Lock, keyRound, CheckCircle2, AlertCircle, Loader2, ArrowLeft } from "lucide-react";
import { authAPI } from "../../api/authApi";
import styles from "./reset.module.css";
import logo from './logo.jpg';

export default function ResetPassword() {
  const { token } = useParams();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ message: "", type: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (password !== confirm) {
      setStatus({ message: "As senhas não coincidem", type: "error" });
      setIsLoading(false);
      return;
    }

    try {
      await authAPI.reset_password(token, { password });
      setStatus({ message: "Senha redefinida com sucesso!", type: "success" });
      setPassword("");
      setConfirm("");
    } catch (err) {
      console.error(err);
      setStatus({ message: "Token inválido ou expirado.", type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* Efeitos de fundo */}
      <div className={styles.blobBlue} />
      <div className={styles.blobGold} />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className={styles.card}
      >
        {/* Logo em destaque */}
        <div className={styles.logoWrapper}>
          <img src={logo} alt="Logo" className={styles.logoImage} />
        </div>

        <header className={styles.header}>
          <h2 className={styles.title}>Nova senha</h2>
          <p className={styles.subtitle}>Defina sua nova credencial de acesso.</p>
        </header>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <div className={styles.inputWrapper}>
              <Lock className={styles.icon} size={18} />
              <input
                className={styles.input}
                type="password"
                placeholder="Nova senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className={styles.field}>
            <div className={styles.inputWrapper}>
              <CheckCircle2 className={styles.icon} size={18} />
              <input
                className={styles.input}
                type="password"
                placeholder="Confirmar senha"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
          </div>

          <motion.button
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            type="submit"
            className={styles.button}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className={styles.spinner} size={20} />
            ) : (
              "Alterar senha"
            )}
          </motion.button>
        </form>

        <AnimatePresence mode="wait">
          {status.message && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, height: 0 }}
              className={`${styles.status} ${status.type === "success" ? styles.success : styles.error
                }`}
            >
              {status.type === "success" ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}
              <span>{status.message}</span>
            </motion.div>
          )}
        </AnimatePresence>

        <div className={styles.footer}>
          <Link to="/login" className={styles.backLink}>
            <ArrowLeft size={16} /> Voltar para o login
          </Link>
        </div>
      </motion.div>
    </div>
  );
}